(function () {
  var isCartUpdating = false;
  var quantityChangeTimer = null;
  var shippingRateRequestId = 0;
  var shippingRateRetryTimer = null;

  function formatMoneyNoCurrency(cents) {
    var amount = Number(cents) || 0;
    return Math.floor(amount / 100).toLocaleString('ja-JP');
  }

  function escapeItemKey(key) {
    if (window.CSS && typeof CSS.escape === 'function') {
      return CSS.escape(key);
    }
    return String(key).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  }

  /**
   * ヘッダー等のカート件数表示を更新（cart オブジェクトから）
   */
  function updateCartCountFromCart(cart) {
    document.querySelectorAll('.cart-count').forEach(function (el) {
      if (cart.item_count > 0) {
        el.textContent = cart.item_count;
        el.classList.add('is-active');
      } else {
        el.classList.remove('is-active');
      }
    });

    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
    });

    var bubble = document.querySelector('[data-cart-count-bubble]');
    if (bubble) {
      if (cart.item_count > 0) {
        bubble.classList.remove('hide');
      } else {
        bubble.classList.add('hide');
      }
    }
  }

  /**
   * ヘッダー等のカート件数表示を更新（/cart.js 取得）
   */
  function updateCartCount() {
    return fetch('/cart.js')
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        updateCartCountFromCart(cart);
        return cart;
      })
      .catch(function (err) {
        console.error(err);
      });
  }

  function getCartSectionId() {
    var container = document.querySelector('[data-section-type="cart-template"]');
    if (!container) return null;
    return container.getAttribute('data-section-id');
  }

  function setCartQtyButtonsDisabled(disabled) {
    document.querySelectorAll('.cart__qty-btn').forEach(function (btn) {
      btn.disabled = disabled;
    });
  }

  function hideQuantityErrors() {
    document
      .querySelectorAll('[data-cart-quantity-error-message-wrapper]')
      .forEach(function (wrapper) {
        wrapper.classList.add('hide');
      });
    document.querySelectorAll('[data-cart-quantity-error-message]').forEach(function (el) {
      el.textContent = '';
    });
  }

  function showQuantityError(itemElement, message) {
    if (!itemElement) return;

    var wrappers = itemElement.querySelectorAll(
      '[data-cart-quantity-error-message-wrapper]'
    );
    var messages = itemElement.querySelectorAll('[data-cart-quantity-error-message]');

    wrappers.forEach(function (wrapper) {
      wrapper.classList.remove('hide');
    });
    messages.forEach(function (el) {
      el.textContent = message;
    });
  }

  function initWcrGuideButtons() {
    document.querySelectorAll('.wcr-guide__button[href^="#"]').forEach(function (a) {
      if (a.dataset.wcrGuideBound === 'true') return;
      a.dataset.wcrGuideBound = 'true';

      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href').slice(1);
        var target = id && document.getElementById(id);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  function initShippingAccordions() {
    document.querySelectorAll('[data-waccara-accordion]').forEach(function (accordion) {
      if (accordion.dataset.shippingAccordionBound === 'true') return;

      var trigger = accordion.querySelector('.waccara-accordion__header');
      var panel = accordion.querySelector('.waccara-accordion__panel');
      if (!trigger || !panel) return;

      accordion.dataset.shippingAccordionBound = 'true';
      trigger.addEventListener('click', function () {
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', expanded ? 'false' : 'true');

        if (expanded) {
          panel.setAttribute('hidden', '');
        } else {
          panel.removeAttribute('hidden');
        }
      });
    });
  }

  function replaceCartSection(html, sectionId) {
    var sectionEl = document.getElementById('shopify-section-' + sectionId);
    if (!sectionEl) return;

    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    var newSection = doc.getElementById('shopify-section-' + sectionId);

    if (newSection) {
      sectionEl.innerHTML = newSection.innerHTML;
    } else {
      sectionEl.innerHTML = html;
    }

    initWcrGuideButtons();
    initShippingAccordions();
    initCartFloatingCheckout();
    initContinueShoppingBack();
  }

  function updateLineItemInDOM(item) {
    var linePrice =
      item.final_line_price != null ? item.final_line_price : item.original_line_price;
    var priceText = formatMoneyNoCurrency(linePrice);
    var rows = document.querySelectorAll(
      '[data-cart-item-key="' + escapeItemKey(item.key) + '"]'
    );

    rows.forEach(function (row) {
      row.setAttribute('data-cart-item-quantity', item.quantity);
      row.querySelectorAll('[data-quantity-input]').forEach(function (inp) {
        inp.value = item.quantity;
      });
      row.querySelectorAll('[data-cart-item-line-price]').forEach(function (cell) {
        var priceEl = cell.querySelector('[data-cart-item-regular-price]');
        if (priceEl) {
          priceEl.textContent = priceText;
        } else {
          cell.innerHTML = priceText + '<span class="tax">円（税込）</span>';
        }
      });
    });
  }

  function getCartItemsSubtotal(cart) {
    if (!cart) return 0;

    if (cart.items_subtotal_price != null) {
      return Number(cart.items_subtotal_price) || 0;
    }

    if (Array.isArray(cart.items)) {
      return cart.items.reduce(function (subtotal, item) {
        var linePrice =
          item.final_line_price != null
            ? item.final_line_price
            : item.original_line_price;
        return subtotal + (Number(linePrice) || 0);
      }, 0);
    }

    return Number(cart.total_price) || 0;
  }

  function updateCartSummary(cart) {
    var box = document.querySelector('[data-cart-summary]');
    if (!box) return;

    var countEl = box.querySelector('[data-cart-summary-count]');
    var totalEl = box.querySelector('[data-cart-summary-total]');

    if (countEl) {
      countEl.innerHTML = cart.item_count + '<span class="unit">点</span>';
    }
    if (totalEl) {
      totalEl.innerHTML =
        formatMoneyNoCurrency(getCartItemsSubtotal(cart)) +
        '<span class="unit">円</span>';
    }
  }

  function getCartLayout() {
    return document.querySelector('[data-cart-layout]');
  }

  function getActiveShippingSize() {
    var rank = 1;
    var label = '小サイズ';

    getUniqueCartItemRows().forEach(function (row) {
      var qty = getQtyForRow(row);
      var rowRank = parseInt(row.getAttribute('data-shipping-rank'), 10) || 1;

      if (qty > 0 && rowRank > rank) {
        rank = rowRank;
        label = row.getAttribute('data-shipping-label') || label;
      }
    });

    return { rank: rank, label: label };
  }

  function getShippingRegion() {
    var select = document.querySelector('[data-shipping-region]');
    var selected = select && select.options[select.selectedIndex];

    return {
      zone: (selected && selected.getAttribute('data-zone')) || 'regular',
      label: (selected && selected.getAttribute('data-region-label')) || '本州',
      name: (selected && selected.textContent.trim()) || '東京都',
      province: (selected && selected.getAttribute('data-province')) || 'Tokyo',
      postalCode: (selected && selected.getAttribute('data-postal-code')) || '100-0001'
    };
  }

  function getAjaxApiRoot() {
    if (window.Shopify && Shopify.routes && Shopify.routes.root) {
      return Shopify.routes.root;
    }
    return '/';
  }

  function updateOrderEstimateElements(
    cartTotal,
    size,
    region,
    state,
    amount,
    freeShippingApplied
  ) {
    var layout = getCartLayout();
    if (!layout) return;

    var labelEl = document.querySelector('[data-shipping-summary-label]');
    var valueEl = document.querySelector('[data-shipping-summary-value]');
    var grandTotalEl = document.querySelector('[data-cart-grand-total]');
    var guideRegionEl = document.querySelector('[data-shipping-guide-region]');
    var guidePriceEl = document.querySelector('[data-shipping-guide-price]');
    var isUnavailable = state === 'unavailable';
    var statusText = isUnavailable ? '決済画面で表示' : '計算中';

    if (labelEl) {
      labelEl.textContent = '送料（' + region.label + '）';
    }
    if (valueEl) {
      valueEl.classList.toggle('is-shipping-unavailable', isUnavailable);
      valueEl.classList.toggle(
        'is-free-shipping',
        state === 'ready' && freeShippingApplied
      );
      valueEl.textContent =
        state === 'ready' ? formatMoneyNoCurrency(amount) + '円' : statusText;
      if (state === 'ready' && freeShippingApplied) {
        valueEl.setAttribute(
          'aria-label',
          '通常送料' + formatMoneyNoCurrency(amount) + '円、送料無料'
        );
      } else {
        valueEl.removeAttribute('aria-label');
      }
    }
    if (grandTotalEl) {
      grandTotalEl.classList.toggle('is-shipping-unavailable', isUnavailable);
      grandTotalEl.textContent =
        state === 'ready'
          ? formatMoneyNoCurrency(
              cartTotal + (freeShippingApplied ? 0 : amount)
            ) + '円'
          : statusText;
    }
    if (guideRegionEl) {
      var guideRegionLabel =
        region.zone === 'remote' ? '北海道・沖縄' : region.label;
      guideRegionEl.textContent =
        region.name + '（' + guideRegionLabel + '）';
    }
    if (guidePriceEl) {
      guidePriceEl.classList.toggle('is-shipping-unavailable', isUnavailable);
      guidePriceEl.classList.toggle(
        'is-free-shipping',
        state === 'ready' && freeShippingApplied
      );
      guidePriceEl.textContent =
        state === 'ready' ? formatMoneyNoCurrency(amount) + '円' : statusText;
      if (state === 'ready' && freeShippingApplied) {
        guidePriceEl.setAttribute(
          'aria-label',
          '通常送料' + formatMoneyNoCurrency(amount) + '円、送料無料'
        );
      } else {
        guidePriceEl.removeAttribute('aria-label');
      }
    }

    layout.setAttribute('aria-busy', state === 'loading' ? 'true' : 'false');
  }

  function getShippingRatesQuery(region) {
    var params = new URLSearchParams();
    params.set('shipping_address[zip]', region.postalCode);
    params.set('shipping_address[country]', 'Japan');
    params.set('shipping_address[province]', region.province);
    return params.toString();
  }

  function pollShippingRates(query, requestId, attempt) {
    if (requestId !== shippingRateRequestId) return Promise.resolve(null);

    return fetch(
      getAjaxApiRoot() + 'cart/async_shipping_rates.json?' + query,
      {
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      }
    )
      .then(function (res) {
        if (!res.ok) throw new Error('Shipping rates request failed');
        return res.json();
      })
      .then(function (data) {
        if (requestId !== shippingRateRequestId) return null;
        if (data && Array.isArray(data.shipping_rates)) return data.shipping_rates;
        if (attempt >= 19) throw new Error('Shipping rates request timed out');

        return new Promise(function (resolve) {
          window.setTimeout(resolve, 500);
        }).then(function () {
          return pollShippingRates(query, requestId, attempt + 1);
        });
      });
  }

  function requestShippingRates(region, requestId) {
    var query = getShippingRatesQuery(region);

    return fetch(
      getAjaxApiRoot() + 'cart/prepare_shipping_rates.json?' + query,
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: ''
      }
    ).then(function (res) {
      if (!res.ok) throw new Error('Shipping rates preparation failed');
      return pollShippingRates(query, requestId, 0);
    });
  }

  function getShippingRateCacheKey(cart, region) {
    var items = (cart.items || [])
      .map(function (item) {
        return item.key + ':' + item.quantity;
      })
      .sort()
      .join('|');

    return 'waccara-shipping-rate:' + region.province + ':' + items;
  }

  function getCachedShippingRate(cart, region) {
    try {
      var value = window.sessionStorage.getItem(
        getShippingRateCacheKey(cart, region)
      );
      if (value == null) return null;

      var amount = parseInt(value, 10);
      return Number.isFinite(amount) ? amount : null;
    } catch (err) {
      return null;
    }
  }

  function setCachedShippingRate(cart, region, amount) {
    try {
      window.sessionStorage.setItem(
        getShippingRateCacheKey(cart, region),
        String(amount)
      );
    } catch (err) {
      // sessionStorageが利用できない環境でも送料取得は継続する
    }
  }

  function scheduleShippingRateRetry(cart, requestId) {
    if (shippingRateRetryTimer) {
      window.clearTimeout(shippingRateRetryTimer);
    }

    shippingRateRetryTimer = window.setTimeout(function () {
      shippingRateRetryTimer = null;
      if (requestId !== shippingRateRequestId) return;
      updateOrderEstimate(cart);
    }, 2000);
  }

  function updateOrderEstimate(cart) {
    var layout = getCartLayout();
    if (!layout || !cart) return Promise.resolve();

    var size = getActiveShippingSize();
    var region = getShippingRegion();
    var cartTotal = getCartItemsSubtotal(cart);
    var freeShippingThreshold =
      parseInt(layout.getAttribute('data-free-shipping-threshold'), 10) || 0;
    var requestId = ++shippingRateRequestId;

    if (shippingRateRetryTimer) {
      window.clearTimeout(shippingRateRetryTimer);
      shippingRateRetryTimer = null;
    }

    updateOrderEstimateElements(cartTotal, size, region, 'loading', 0);

    if (cart.requires_shipping === false) {
      updateOrderEstimateElements(cartTotal, size, region, 'ready', 0);
      return Promise.resolve();
    }

    return requestShippingRates(region, requestId)
      .then(function (rates) {
        if (requestId !== shippingRateRequestId || !rates) return;

        if (!rates.length) {
          updateOrderEstimateElements(
            cartTotal,
            size,
            region,
            'unavailable',
            0
          );
          return;
        }

        var rate = rates.reduce(function (lowestRate, currentRate) {
          if (!lowestRate) return currentRate;
          return parseFloat(currentRate.price) < parseFloat(lowestRate.price)
            ? currentRate
            : lowestRate;
        }, null);
        var amount = Math.round((parseFloat(rate.price) || 0) * 100);
        var compareAmount = Math.round(
          (parseFloat(rate.compare_price) || 0) * 100
        );
        var freeShippingApplied =
          freeShippingThreshold > 0 && cartTotal >= freeShippingThreshold;
        var displayedAmount =
          freeShippingApplied && compareAmount > 0 ? compareAmount : amount;

        setCachedShippingRate(cart, region, displayedAmount);
        updateOrderEstimateElements(
          cartTotal,
          size,
          region,
          'ready',
          displayedAmount,
          freeShippingApplied
        );
      })
      .catch(function (err) {
        if (requestId !== shippingRateRequestId) return;

        var cachedAmount = getCachedShippingRate(cart, region);
        if (cachedAmount != null) {
          updateOrderEstimateElements(
            cartTotal,
            size,
            region,
            'ready',
            cachedAmount,
            freeShippingThreshold > 0 && cartTotal >= freeShippingThreshold
          );
        } else {
          updateOrderEstimateElements(cartTotal, size, region, 'loading', 0);
        }

        console.warn('Shipping rate will be retried automatically.', err);
        scheduleShippingRateRetry(cart, requestId);
      });
  }

  function updateFreeShippingBox(cart) {
    var layout = getCartLayout();
    var box = document.querySelector('[data-free-shipping-box]');
    if (!layout || !box) return;

    var cartTotal = getCartItemsSubtotal(cart);
    box.classList.toggle('hide', cartTotal === 0);
    if (cartTotal === 0) return;

    var threshold =
      parseInt(layout.getAttribute('data-free-shipping-threshold'), 10) || 0;
    var remaining = threshold - cartTotal;
    var textEl = box.querySelector('[data-free-shipping-text]');
    var progressEl = box.querySelector('[data-free-shipping-progress]');
    var relatedFreeShippingEl = document.querySelector(
      '[data-related-free-shipping]'
    );
    if (!textEl) return;

    if (remaining > 0) {
      textEl.innerHTML =
        '送料無料まで <strong>あと <span class="free-shipping-box__amount">' +
        formatMoneyNoCurrency(remaining) +
        '</span>円</strong>（' +
        formatMoneyNoCurrency(threshold) +
        '円以上で送料無料）';
    } else {
      textEl.innerHTML =
        '送料無料の条件を達成しています（' +
        formatMoneyNoCurrency(threshold) +
        '円以上）';
    }

    if (relatedFreeShippingEl) {
      relatedFreeShippingEl.textContent =
        remaining > 0
          ? 'あと' + formatMoneyNoCurrency(remaining) + '円で送料無料'
          : '送料無料の条件を達成';
    }

    if (progressEl) {
      var progress = threshold > 0 ? (cartTotal / threshold) * 100 : 100;
      progressEl.style.width = Math.max(0, Math.min(100, progress)) + '%';
    }
  }

  /**
   * change.js の JSON から DOM を部分更新（軽量パス）
   */
  function updateCartUIFromJson(cart) {
    var itemsByKey = {};

    cart.items.forEach(function (item) {
      itemsByKey[item.key] = item;
      updateLineItemInDOM(item);
    });

    document.querySelectorAll('[data-cart-item]').forEach(function (row) {
      var key = row.getAttribute('data-cart-item-key');
      if (!itemsByKey[key]) {
        row.remove();
      }
    });

    updateCartSummary(cart);
    updateFreeShippingBox(cart);
    updateOrderEstimate(cart);
    updateCartCountFromCart(cart);
  }

  /**
   * カート数量変更
   * @param {Object} [optimistic] - { itemIndex, previousQty } エラー時ロールバック用
   */
  function changeCartQuantity(lineItemKey, quantity, itemElement, optimistic) {
    if (isCartUpdating) return Promise.resolve();

    var sectionId = getCartSectionId();
    if (!sectionId && quantity === 0) {
      return Promise.reject(new Error('Cart section not found'));
    }

    var useSectionRender = quantity === 0;
    var regionSelect = document.querySelector('[data-shipping-region]');
    var selectedRegion = regionSelect && regionSelect.value;

    isCartUpdating = true;
    setCartQtyButtonsDisabled(true);
    hideQuantityErrors();

    var body = {
      id: lineItemKey,
      quantity: quantity
    };

    if (useSectionRender) {
      body.sections = sectionId;
      body.sections_url = '/cart';
    }

    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw data;
          return data;
        });
      })
      .then(function (data) {
        if (useSectionRender && data.sections && data.sections[sectionId]) {
          replaceCartSection(data.sections[sectionId], sectionId);
          var newRegionSelect = document.querySelector('[data-shipping-region]');
          if (newRegionSelect && selectedRegion) {
            newRegionSelect.value = selectedRegion;
          }
          updateCartSummary(data);
          updateFreeShippingBox(data);
          updateOrderEstimate(data);
          updateCartCountFromCart(data);
        } else {
          updateCartUIFromJson(data);
        }
      })
      .catch(function (err) {
        if (optimistic && optimistic.snapshot) {
          restoreCartSnapshot(optimistic.snapshot);
        } else if (optimistic && optimistic.itemIndex != null) {
          syncQuantityInputs(optimistic.itemIndex, optimistic.previousQty);
        }
        var message =
          (err && (err.description || err.message)) ||
          '数量を更新できませんでした。';
        showQuantityError(itemElement, message);
        console.error(err);
      })
      .finally(function () {
        isCartUpdating = false;
        setCartQtyButtonsDisabled(false);
      });
  }

  function getItemElementFromTarget(target) {
    return target.closest('[data-cart-item]');
  }

  function getLineItemKey(itemElement) {
    return itemElement && itemElement.getAttribute('data-cart-item-key');
  }

  function syncQuantityInputs(itemIndex, value) {
    document
      .querySelectorAll('[data-quantity-item="' + itemIndex + '"]')
      .forEach(function (input) {
        input.value = value;
      });
  }

  function getUniqueCartItemRows() {
    var seen = {};
    var rows = [];

    document.querySelectorAll('[data-cart-item]').forEach(function (row) {
      var key = row.getAttribute('data-cart-item-key');
      if (!key || seen[key]) return;
      seen[key] = true;
      rows.push(row);
    });

    return rows;
  }

  function getQtyForRow(row) {
    var input = row.querySelector('[data-quantity-input]');
    return parseInt(input && input.value, 10) || 0;
  }

  function applyLinePriceToRows(key, linePriceCents) {
    var priceText = formatMoneyNoCurrency(linePriceCents);

    document
      .querySelectorAll('[data-cart-item-key="' + escapeItemKey(key) + '"]')
      .forEach(function (row) {
        row.querySelectorAll('[data-cart-item-line-price]').forEach(function (cell) {
          var priceEl = cell.querySelector('[data-cart-item-regular-price]');
          if (priceEl) {
            priceEl.textContent = priceText;
          } else {
            cell.innerHTML = priceText + '<span class="tax">円（税込）</span>';
          }
        });
      });
  }

  function computeOptimisticCartTotals(changedKey, newQty) {
    var totalCents = 0;
    var itemCount = 0;

    getUniqueCartItemRows().forEach(function (row) {
      var key = row.getAttribute('data-cart-item-key');
      var unitCents = parseInt(row.getAttribute('data-unit-price-cents'), 10) || 0;
      var qty = key === changedKey ? newQty : getQtyForRow(row);

      totalCents += unitCents * qty;
      itemCount += qty;
    });

    return {
      total_price: totalCents,
      items_subtotal_price: totalCents,
      item_count: itemCount
    };
  }

  function optimisticUpdateUI(changedKey, newQty, itemIndex) {
    if (itemIndex) {
      syncQuantityInputs(itemIndex, newQty);
    }

    document
      .querySelectorAll('[data-cart-item-key="' + escapeItemKey(changedKey) + '"]')
      .forEach(function (row) {
        row.setAttribute('data-cart-item-quantity', newQty);
      });

    var firstRow = document.querySelector(
      '[data-cart-item-key="' + escapeItemKey(changedKey) + '"]'
    );
    var unitCents =
      parseInt(firstRow && firstRow.getAttribute('data-unit-price-cents'), 10) || 0;

    applyLinePriceToRows(changedKey, unitCents * newQty);

    var totals = computeOptimisticCartTotals(changedKey, newQty);
    updateCartSummary(totals);
    updateFreeShippingBox(totals);
    shippingRateRequestId += 1;
    updateOrderEstimateElements(
      totals.total_price,
      getActiveShippingSize(),
      getShippingRegion(),
      'loading',
      0
    );
    updateCartCountFromCart(totals);
  }

  function captureCartSnapshot() {
    var snapshot = {
      items: {},
      summaryCount: null,
      summaryTotal: null,
      freeShippingText: null,
      freeShippingProgress: null,
      relatedFreeShippingText: null,
      shippingSummaryLabel: null,
      shippingSummaryValue: null,
      grandTotal: null,
      cartCounts: []
    };

    getUniqueCartItemRows().forEach(function (row) {
      var key = row.getAttribute('data-cart-item-key');
      var input = row.querySelector('[data-quantity-input]');
      var linePriceCells = [];

      document
        .querySelectorAll('[data-cart-item-key="' + escapeItemKey(key) + '"]')
        .forEach(function (r) {
          r.querySelectorAll('[data-cart-item-line-price]').forEach(function (cell) {
            linePriceCells.push(cell.innerHTML);
          });
        });

      snapshot.items[key] = {
        qty: row.getAttribute('data-cart-item-quantity'),
        itemIndex: input && input.getAttribute('data-quantity-item'),
        linePriceCells: linePriceCells
      };
    });

    var countEl = document.querySelector('[data-cart-summary-count]');
    var totalEl = document.querySelector('[data-cart-summary-total]');
    if (countEl) snapshot.summaryCount = countEl.innerHTML;
    if (totalEl) snapshot.summaryTotal = totalEl.innerHTML;

    var textEl = document.querySelector('[data-free-shipping-text]');
    if (textEl) snapshot.freeShippingText = textEl.innerHTML;

    var progressEl = document.querySelector('[data-free-shipping-progress]');
    var relatedFreeShippingEl = document.querySelector(
      '[data-related-free-shipping]'
    );
    var shippingLabelEl = document.querySelector('[data-shipping-summary-label]');
    var shippingValueEl = document.querySelector('[data-shipping-summary-value]');
    var grandTotalEl = document.querySelector('[data-cart-grand-total]');
    if (progressEl) snapshot.freeShippingProgress = progressEl.style.width;
    if (relatedFreeShippingEl) {
      snapshot.relatedFreeShippingText = relatedFreeShippingEl.textContent;
    }
    if (shippingLabelEl) snapshot.shippingSummaryLabel = shippingLabelEl.textContent;
    if (shippingValueEl) snapshot.shippingSummaryValue = shippingValueEl.textContent;
    if (grandTotalEl) snapshot.grandTotal = grandTotalEl.textContent;

    document.querySelectorAll('.cart-count').forEach(function (el) {
      snapshot.cartCounts.push({
        text: el.textContent,
        active: el.classList.contains('is-active')
      });
    });

    return snapshot;
  }

  function restoreCartSnapshot(snapshot) {
    if (!snapshot) return;

    Object.keys(snapshot.items).forEach(function (key) {
      var item = snapshot.items[key];

      if (item.itemIndex) {
        syncQuantityInputs(item.itemIndex, item.qty);
      }

      document
        .querySelectorAll('[data-cart-item-key="' + escapeItemKey(key) + '"]')
        .forEach(function (row) {
          row.setAttribute('data-cart-item-quantity', item.qty);
        });

      var cellIndex = 0;
      document
        .querySelectorAll('[data-cart-item-key="' + escapeItemKey(key) + '"]')
        .forEach(function (r) {
          r.querySelectorAll('[data-cart-item-line-price]').forEach(function (cell) {
            if (item.linePriceCells[cellIndex] != null) {
              cell.innerHTML = item.linePriceCells[cellIndex];
            }
            cellIndex += 1;
          });
        });
    });

    var countEl = document.querySelector('[data-cart-summary-count]');
    var totalEl = document.querySelector('[data-cart-summary-total]');
    if (countEl && snapshot.summaryCount != null) {
      countEl.innerHTML = snapshot.summaryCount;
    }
    if (totalEl && snapshot.summaryTotal != null) {
      totalEl.innerHTML = snapshot.summaryTotal;
    }

    var textEl = document.querySelector('[data-free-shipping-text]');
    if (textEl && snapshot.freeShippingText != null) {
      textEl.innerHTML = snapshot.freeShippingText;
    }

    var progressEl = document.querySelector('[data-free-shipping-progress]');
    var relatedFreeShippingEl = document.querySelector(
      '[data-related-free-shipping]'
    );
    var shippingLabelEl = document.querySelector('[data-shipping-summary-label]');
    var shippingValueEl = document.querySelector('[data-shipping-summary-value]');
    var grandTotalEl = document.querySelector('[data-cart-grand-total]');
    if (progressEl && snapshot.freeShippingProgress != null) {
      progressEl.style.width = snapshot.freeShippingProgress;
    }
    if (relatedFreeShippingEl && snapshot.relatedFreeShippingText != null) {
      relatedFreeShippingEl.textContent = snapshot.relatedFreeShippingText;
    }
    if (shippingLabelEl && snapshot.shippingSummaryLabel != null) {
      shippingLabelEl.textContent = snapshot.shippingSummaryLabel;
    }
    if (shippingValueEl && snapshot.shippingSummaryValue != null) {
      shippingValueEl.textContent = snapshot.shippingSummaryValue;
    }
    if (grandTotalEl && snapshot.grandTotal != null) {
      grandTotalEl.textContent = snapshot.grandTotal;
    }

    var cartCountEls = document.querySelectorAll('.cart-count');
    cartCountEls.forEach(function (el, i) {
      var saved = snapshot.cartCounts[i];
      if (!saved) return;
      el.textContent = saved.text;
      if (saved.active) {
        el.classList.add('is-active');
      } else {
        el.classList.remove('is-active');
      }
    });

    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      if (snapshot.cartCounts[0]) {
        el.textContent = snapshot.cartCounts[0].text;
      }
    });
  }

  var cartGalleryImages = [];
  var cartGalleryIndex = 0;
  var cartGalleryTrigger = null;

  function getCartGalleryModal() {
    var bodyModal = document.querySelector('body > [data-cart-gallery-modal]');

    if (bodyModal) {
      document.querySelectorAll('[data-cart-gallery-modal]').forEach(function (modal) {
        if (modal !== bodyModal) modal.remove();
      });
      return bodyModal;
    }

    var modal = document.querySelector('[data-cart-gallery-modal]');
    if (modal && document.body) {
      document.body.appendChild(modal);
    }
    return modal;
  }

  function setCartGalleryImage(index) {
    var modal = getCartGalleryModal();
    if (!modal || !cartGalleryImages.length) return;

    cartGalleryIndex = (index + cartGalleryImages.length) % cartGalleryImages.length;

    var image = cartGalleryImages[cartGalleryIndex];
    var mainImage = modal.querySelector('[data-cart-gallery-main]');
    var counter = modal.querySelector('[data-cart-gallery-counter]');

    if (mainImage) {
      mainImage.src = image.src;
      mainImage.alt = image.alt;
    }
    if (counter) {
      counter.textContent = cartGalleryIndex + 1 + ' / ' + cartGalleryImages.length;
    }

    modal.querySelectorAll('[data-cart-gallery-thumbnail]').forEach(function (button, i) {
      var isCurrent = i === cartGalleryIndex;
      button.classList.toggle('is-current', isCurrent);
      button.setAttribute('aria-current', isCurrent ? 'true' : 'false');

      if (isCurrent) {
        button.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    });
  }

  function renderCartGalleryThumbnails(modal) {
    var container = modal.querySelector('[data-cart-gallery-thumbnails]');
    if (!container) return;

    container.innerHTML = '';

    cartGalleryImages.forEach(function (image, index) {
      var button = document.createElement('button');
      var thumbnail = document.createElement('img');

      button.type = 'button';
      button.className = 'cart-gallery-modal__thumbnail';
      button.setAttribute('aria-label', (index + 1) + '枚目の画像を表示');
      button.setAttribute('data-cart-gallery-thumbnail', index);

      thumbnail.src = image.thumb;
      thumbnail.alt = '';
      thumbnail.width = 80;
      thumbnail.height = 80;
      thumbnail.loading = 'lazy';

      button.appendChild(thumbnail);
      container.appendChild(button);
    });
  }

  function openCartGallery(trigger) {
    var modal = getCartGalleryModal();
    var item = trigger && trigger.closest('[data-cart-item]');
    if (!modal || !item) return;

    var currentIndex = 0;
    cartGalleryImages = Array.prototype.map.call(
      item.querySelectorAll('[data-cart-gallery-image]'),
      function (imageData, index) {
        if (imageData.hasAttribute('data-gallery-current')) currentIndex = index;
        return {
          src: imageData.getAttribute('data-gallery-src'),
          thumb: imageData.getAttribute('data-gallery-thumb'),
          alt: imageData.getAttribute('data-gallery-alt') || '商品画像'
        };
      }
    );

    if (!cartGalleryImages.length) return;

    cartGalleryTrigger = trigger;
    var title = modal.querySelector('[data-cart-gallery-title]');
    var itemTitle = item.getAttribute('data-cart-item-title') || '商品画像';
    var arrows = modal.querySelectorAll('[data-cart-gallery-prev], [data-cart-gallery-next]');

    if (title) title.textContent = itemTitle;
    arrows.forEach(function (arrow) {
      arrow.hidden = cartGalleryImages.length < 2;
    });

    renderCartGalleryThumbnails(modal);
    modal.hidden = false;
    document.body.classList.add('cart-gallery-is-open');
    setCartGalleryImage(currentIndex);

    var closeButton = modal.querySelector('.cart-gallery-modal__close');
    if (closeButton) closeButton.focus();
  }

  function closeCartGallery() {
    var modal = getCartGalleryModal();
    if (!modal || modal.hidden) return;

    modal.hidden = true;
    document.body.classList.remove('cart-gallery-is-open');

    if (cartGalleryTrigger && document.contains(cartGalleryTrigger)) {
      cartGalleryTrigger.focus();
    }
    cartGalleryTrigger = null;
  }

  function bindCartGallery() {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-cart-gallery-trigger]');
      if (trigger) {
        e.preventDefault();
        openCartGallery(trigger);
        return;
      }

      if (e.target.closest('[data-cart-gallery-close]')) {
        closeCartGallery();
        return;
      }

      if (e.target.closest('[data-cart-gallery-prev]')) {
        setCartGalleryImage(cartGalleryIndex - 1);
        return;
      }

      if (e.target.closest('[data-cart-gallery-next]')) {
        setCartGalleryImage(cartGalleryIndex + 1);
        return;
      }

      var thumbnail = e.target.closest('[data-cart-gallery-thumbnail]');
      if (thumbnail) {
        setCartGalleryImage(
          parseInt(thumbnail.getAttribute('data-cart-gallery-thumbnail'), 10) || 0
        );
      }
    });

    document.addEventListener('keydown', function (e) {
      var modal = getCartGalleryModal();
      if (!modal || modal.hidden) return;

      if (e.key === 'Escape') {
        e.preventDefault();
        closeCartGallery();
      } else if (e.key === 'ArrowLeft' && cartGalleryImages.length > 1) {
        e.preventDefault();
        setCartGalleryImage(cartGalleryIndex - 1);
      } else if (e.key === 'ArrowRight' && cartGalleryImages.length > 1) {
        e.preventDefault();
        setCartGalleryImage(cartGalleryIndex + 1);
      }
    });
  }

  function bindCartPageInteractions() {
    document.addEventListener('change', function (e) {
      if (!e.target.matches('[data-shipping-region]')) return;
      updateCartCount().then(function (cart) {
        if (cart) updateOrderEstimate(cart);
      });
    });

    document.addEventListener('click', function (e) {
      var removeLink = e.target.closest('[data-cart-remove]');
      if (removeLink && removeLink.closest('form.cart')) {
        e.preventDefault();
        e.stopImmediatePropagation();

        var itemElement = getItemElementFromTarget(removeLink);
        var key = removeLink.dataset.lineKey || getLineItemKey(itemElement);
        if (!key) return;

        changeCartQuantity(key, 0, itemElement);
        return;
      }

      var plusBtn = e.target.closest('.cart__qty-btn--plus');
      var minusBtn = e.target.closest('.cart__qty-btn--minus');
      var qtyBtn = plusBtn || minusBtn;

      if (!qtyBtn || !qtyBtn.closest('form.cart')) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      var qtyWrap = qtyBtn.closest('.cart__qty');
      var input = qtyWrap && qtyWrap.querySelector('.cart__qty-input');
      if (!input) return;

      var itemElement = getItemElementFromTarget(qtyBtn);
      var key = getLineItemKey(itemElement);
      if (!key) return;

      var itemIndex = input.getAttribute('data-quantity-item');
      var currentQty = parseInt(input.value, 10) || 0;
      var minValue = parseInt(input.getAttribute('min'), 10) || 0;
      var newQty = plusBtn ? currentQty + 1 : Math.max(minValue, currentQty - 1);

      var snapshot = captureCartSnapshot();
      optimisticUpdateUI(key, newQty, itemIndex);

      changeCartQuantity(key, newQty, itemElement, {
        itemIndex: itemIndex,
        previousQty: currentQty,
        snapshot: snapshot
      });
    });

    document.addEventListener(
      'change',
      function (e) {
        if (!e.target.hasAttribute('data-quantity-input')) return;
        if (!e.target.closest('form.cart')) return;

        e.stopImmediatePropagation();

        var input = e.target;
        var itemElement = getItemElementFromTarget(input);
        var key = getLineItemKey(itemElement);
        if (!key) return;

        var value = parseInt(input.value, 10);
        var itemIndex = input.getAttribute('data-quantity-item');
        var previousQty = parseInt(
          itemElement.getAttribute('data-cart-item-quantity'),
          10
        );

        if (isNaN(value) || value < 0) {
          showQuantityError(itemElement, '有効な数量を入力してください。');
          return;
        }

        if (itemIndex) {
          syncQuantityInputs(itemIndex, value);
        }

        clearTimeout(quantityChangeTimer);
        quantityChangeTimer = setTimeout(function () {
          changeCartQuantity(key, value, itemElement, {
            itemIndex: itemIndex,
            previousQty: isNaN(previousQty) ? value : previousQty
          });
        }, 500);
      },
      true
    );
  }

  function bindAddToCartModal() {
    document.querySelectorAll('form[action="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var formData = new FormData(form);

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { Accept: 'application/json' }
        })
          .then(function (res) {
            return res.json();
          })
          .then(function () {
            updateCartCount();
            var modal = document.getElementById('cart-modal');
            if (modal) modal.classList.add('is-active');
          })
          .catch(function (err) {
            console.error(err);
          });
      });
    });

    var modal = document.getElementById('cart-modal');
    if (!modal) return;

    var inner = modal.querySelector('.cart-modal__inner');

    modal.addEventListener('click', function () {
      modal.classList.remove('is-active');
    });

    if (inner) {
      inner.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    }

    document.querySelectorAll('.js-close-modal').forEach(function (btn) {
      btn.addEventListener('click', function () {
        modal.classList.remove('is-active');
      });
    });
  }

  /**
   * PC：元のカート追加ボタンが画面外＋数100pxスクロールしたら
   * 下部追従ボタンを表示する。フッターが画面内に入ったら非表示にする。
   *
   * 実ボタンをその場で position:fixed にすると、商品フォームの祖先に
   * transform 等があった場合に fixed の基準がビューポートにならず追従
   * しないため、body 直下にクローンを生成して表示・非表示を切り替える。
   * クリックは実ボタンへ転送する（カート追加／ふすまリンクをそのまま発火）。
   * 表示判定は、流れ内に置いたセンチネルとフッターを監視して行う。
   */
  function initFloatingCartCta() {
    var sentinel = document.querySelector('.cart-cta-sentinel');
    var realCta = document.querySelector('.product-form__cart-submit');
    if (!sentinel || !realCta || !('IntersectionObserver' in window)) return;

    var wrapper = document.createElement('div');
    wrapper.className = 'floating-cart-cta';
    wrapper.hidden = true;

    var clone = realCta.cloneNode(true);
    clone.removeAttribute('id');
    clone.removeAttribute('data-add-to-cart');
    clone.className = 'floating-cart-cta__btn'; // 既存クラス由来のルールを引き継がない
    if (clone.tagName === 'BUTTON') clone.type = 'button';
    clone.addEventListener('click', function (e) {
      e.preventDefault();
      realCta.click();
    });

    wrapper.appendChild(clone);
    document.body.appendChild(wrapper);

    var footer = document.getElementById('shopify-section-footer');
    var pastSentinel = false;
    var footerVisible = false;

    function update() {
      // センチネルを通過し、かつフッターが画面内に入っていない時だけ表示
      wrapper.hidden = !(pastSentinel && !footerVisible);
    }

    var sentinelObserver = new IntersectionObserver(
      function (entries) {
        var entry = entries[0];
        // センチネルが上端より上（=スクロールで通過）かつ rootMargin 分を超えたら true
        pastSentinel = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        update();
      },
      { rootMargin: '300px 0px 0px 0px', threshold: 0 }
    );
    sentinelObserver.observe(sentinel);

    if (footer) {
      var footerObserver = new IntersectionObserver(
        function (entries) {
          footerVisible = entries[0].isIntersecting;
          update();
        },
        // 下方向に 300px 拡張し、フッターが画面に入る 300px 手前で非表示にする
        { rootMargin: '0px 0px 300px 0px', threshold: 0 }
      );
      footerObserver.observe(footer);
    }
  }

  var cartFloatingCheckoutObserver = null;
  var cartFloatingCheckoutFooterObserver = null;

  function initCartFloatingCheckout() {
    if (cartFloatingCheckoutObserver) {
      cartFloatingCheckoutObserver.disconnect();
      cartFloatingCheckoutObserver = null;
    }
    if (cartFloatingCheckoutFooterObserver) {
      cartFloatingCheckoutFooterObserver.disconnect();
      cartFloatingCheckoutFooterObserver = null;
    }

    var existingWrapper = document.querySelector('[data-cart-floating-checkout]');
    if (existingWrapper) existingWrapper.remove();

    var guide = document.querySelector('[data-cart-shipping-guide]');
    var realCheckout = document.querySelector('.cart-order-summary__checkout');
    if (!guide || !realCheckout || !('IntersectionObserver' in window)) return;

    var wrapper = document.createElement('div');
    wrapper.className = 'cart-floating-checkout';
    wrapper.setAttribute('data-cart-floating-checkout', '');
    wrapper.setAttribute('aria-hidden', 'true');

    var button = realCheckout.cloneNode(true);
    button.removeAttribute('name');
    button.className = 'cart-floating-checkout__button';
    button.type = 'button';
    button.tabIndex = -1;
    button.addEventListener('click', function (event) {
      event.preventDefault();
      var currentCheckout = document.querySelector('.cart-order-summary__checkout');
      if (currentCheckout) currentCheckout.click();
    });

    wrapper.appendChild(button);
    document.body.appendChild(wrapper);

    var guideReached = false;
    var footerVisible = false;

    function updateFloatingCheckout() {
      var shouldShow = guideReached && !footerVisible;
      wrapper.classList.toggle('is-visible', shouldShow);
      wrapper.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      button.tabIndex = shouldShow ? 0 : -1;
    }

    cartFloatingCheckoutObserver = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      guideReached = entry.isIntersecting || entry.boundingClientRect.top < 0;
      updateFloatingCheckout();
    }, { threshold: 0 });
    cartFloatingCheckoutObserver.observe(guide);

    var footer = document.getElementById('shopify-section-footer');
    if (footer) {
      cartFloatingCheckoutFooterObserver = new IntersectionObserver(function (entries) {
        footerVisible = entries[0].isIntersecting;
        updateFloatingCheckout();
      }, { threshold: 0 });
      cartFloatingCheckoutFooterObserver.observe(footer);
    }
  }

  function initContinueShoppingBack() {
    document.querySelectorAll('[data-continue-shopping-back]').forEach(function (link) {
      if (link.dataset.continueShoppingBound === 'true') return;
      link.dataset.continueShoppingBound = 'true';

      link.addEventListener('click', function (event) {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
          return;
        }

        if (window.history.length <= 1) return;

        event.preventDefault();
        window.history.back();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    updateCartCount().then(function (cart) {
      if (cart) updateOrderEstimate(cart);
    });
    bindCartPageInteractions();
    bindAddToCartModal();
    bindCartGallery();
    initWcrGuideButtons();
    initShippingAccordions();
    initFloatingCartCta();
    initCartFloatingCheckout();
    initContinueShoppingBack();
  });
})();
